/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Chars_LabelInputs */

const en_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Characters`)
};

const fr_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de caractères`)
};

const de_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichenanzahl`)
};

const it_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri`)
};

const ru_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов`)
};

const es_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres`)
};

const zh_cn2_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大字符数`)
};

const ja_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大文字数`)
};

const hi_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम अक्षर`)
};

const pt_pt2_audio_description_export_subtitle_max_chars_label = /** @type {(inputs: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres`)
};

/**
* | output |
* | --- |
* | "Maximum Characters" |
*
* @param {Audio_Description_Export_Subtitle_Max_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_chars_label = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "de") return de_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "it") return it_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "ru") return ru_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "es") return es_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "ja") return ja_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "hi") return hi_audio_description_export_subtitle_max_chars_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_subtitle_max_chars_label(inputs)
	return en_audio_description_export_subtitle_max_chars_label(inputs)
});